import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { Radio } from 'semantic-ui-react';
import { settings } from 'cluster';
import Option from './Option';

const SectionWrap = styled.div`
  border-bottom: 1px solid #e5e5ea;
  display: flex;
`;
const Header = styled.div`
  font-weight: 700;
  font-size: 16px;
  width: 357px;
`;

interface IProps {
  clientSetting: NewClientSetting;
  setCompanySettings: any;
  children: React.ReactChildren | React.ReactChild;
  index: number
}

export default function Setting(props: IProps) {
  return (
    <SectionWrap>
      <div style={{ padding: 35, display: 'flex' }}>
        <Header>{props.clientSetting.setting.statement}</Header>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div style={{ display: 'flex' }}>
            {props.clientSetting.setting.settingOptions.map((option, index) => (
              <Option
                label={props.clientSetting.setting.settingName}
                option={option}
                selectedValue={props.clientSetting.selectedOptionId}
                setCompanySettings={props.setCompanySettings}
                settingName={props.clientSetting.setting.settingName}
                index={index}
              />
            ))}
          </div>
          {props.children}
        </div>
      </div>
    </SectionWrap>
  );
}